var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "27px",
    viewBox: "0 0 31 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(-462.000000, -644.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-file-pdf",
    transform: "translate(462.353081, 644.001000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,10 L19,7 L13,1.77635684e-15 L2.003,1.77635684e-15 C0.897,1.77635684e-15 -1.77635684e-15,0.898 -1.77635684e-15,2.007 L-1.77635684e-15,24.992 C-1.77635684e-15,26.101 0.891,26.999 1.997,26.999 L17.002,26.999 C18.105,26.999 18.999,26.101 18.999,25.008 L18.999,22.999 L26.992,22.999 C28.653,22.999 29.999,21.657 29.999,20 L29.999,12.998 C29.999,11.342 28.663,9.999 26.992,9.999 L18.999,9.999 L19,10 Z M18,23 L18,25.007 C18,25.555 17.552,26 17,26 L2,26 C1.455,26 1,25.554 1,25.005 L1,1.996 C1,1.456 1.446,1.001 1.996,1.001 L12,1.001 L12,5.995 C12,7.114 12.895,8.001 13.998,8.001 L18,8.001 L18,10.001 L10.007,10.001 C8.346,10.001 7,11.343 7,13 L7,20.002 C7,21.658 8.336,23.001 10.007,23.001 L18,23.001 L18,23 Z M13,1.5 L17.7,7 L13.997,7 C13.451,7 13,6.548 13,5.991 L13,1.5 Z M9.995,11 L27.006,11 C28.098,11 29.001,11.892 29.001,12.992 L29.001,20.008 C29.001,21.1 28.108,22 27.006,22 L9.995,22 C8.903,22 8,21.108 8,20.008 L8,12.992 C8,11.9 8.893,11 9.995,11 L9.995,11 Z M23,16 L23,14 L27,14 L27,13 L22,13 L22,20 L23,20 L23,17 L26,17 L26,16 L23,16 Z M10,15 L10,13 L12.995,13 C14.106,13 15,13.895 15,15 C15,16.112 14.102,17 12.995,17 L11,17 L11,20 L10,20 L10,15 Z M11,14 L11,16 L13.001,16 C13.553,16 14,15.556 14,15 C14,14.448 13.557,14 13.001,14 L11,14 Z M16,13 L18.995,13 C20.106,13 21,13.898 21,15.006 L21,17.994 C21,19.113 20.102,20 18.995,20 L16,20 L16,13 Z M17,14 L17,19 L19.001,19 C19.553,19 20,18.556 20,18 L20,15 C20,14.448 19.557,14 19.001,14 L17,14 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilePdf);
export default __webpack_public_path__ + "static/media/document-file-pdf.2d564f95141f6a71528e24c09708cc7c.svg";
export { ForwardRef as ReactComponent };